exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vertical-data {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  margin-bottom: 15px; }\n  .vertical-data label {\n    font-size: 12px;\n    margin: 0;\n    color: #939393; }\n\n.cuit-cont {\n  display: -ms-flexbox;\n  display: flex; }\n  .cuit-cont div:nth-child(1) {\n    width: 50%;\n    padding-right: 5px; }\n  .cuit-cont div:nth-child(1) {\n    width: 50%;\n    padding-left: 5px; }\n\n.blue {\n  color: #156ebc !important; }\n\n.chips-title {\n  font-size: 12px;\n  color: #939393;\n  text-transform: uppercase;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/usuarios/usuario-agro-detail/usuario-agro-detail.component.scss
// module id = ../../../../../src/app/components/cuentas/usuarios/usuario-agro-detail/usuario-agro-detail.component.scss
// module chunks = 0